import classNames from "classnames";
import React, { PropsWithChildren, useState } from "react";
import { Accordion, Icon, Header } from "semantic-ui-react";

// Specific Component for Notify Subscription Groups collapsible section that can have a sublabel with an icon, and an icon to add/remove contact methods from a group
export function NotifySubscriptionGroupCollapsibleSection({
  title,
  indent = true,
  children,
  titleSubLabel,
  icon,
}: PropsWithChildren<{
  title: string;
  indent?: boolean;
  titleSubLabel?: React.ReactElement;
  icon?: React.ReactElement | null;
}>) {
  const [active, setActive] = useState(false);

  return (
    <Accordion className='tw-border-none'>
      <Accordion.Title
        active={active}
        onClick={() => setActive((prev) => !prev)}
        className='tw-flex tw-select-none tw-items-center'
      >
        <Icon name='dropdown' />
        <Header as='h5' className='tw-m-0'>
          {title}
        </Header>
        {titleSubLabel && <div className='tw-ml-2'>{titleSubLabel}</div>}
        {icon && <div className='tw-ml-auto'>{icon}</div>}
      </Accordion.Title>
      <Accordion.Content className={classNames("tw-pt-0", { "tw-ml-6": !!indent })} active={active}>
        {children}
      </Accordion.Content>
    </Accordion>
  );
}
